import { render } from "./EditSystem.vue?vue&type=template&id=560121fb"
import script from "./EditSystem.vue?vue&type=script&lang=js"
export * from "./EditSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__